import * as Yup from "yup";

export const ClassFormValidation = Yup.object().shape({
  name: Yup.string().required("Name is required!").nullable(),
  amount: Yup.number()
    .required("Subscripion cost is required!")
    .nullable().moreThan(-1, "Subscription cost must be greater than or equal to 0!")
    // .test(
    //   "Is positive?",
    //   "ERROR: The number must be greater than or equal to 0!",
    //   (value: any) => value >= 0
    // ),
});
